import { useImpersonation } from '@thesisedu/feature-apollo-react'
import { useDevTab } from '@thesisedu/feature-react'

import { ClassSyncViewItemOpts } from '../devtools'

export function useSyncAssignmentDevtools(opts: ClassSyncViewItemOpts | null) {
  const { coreAuthKey } = useImpersonation()
  useDevTab('syncHistory', coreAuthKey ? opts ?? undefined : undefined)
}
